export const ONE_DAY_COOKIE_EXPIRED_DATE = 1000 * 60 * 60 * 24;
